import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TIPPY_REF } from '@ngneat/helipopper';

import { ConvertDirective } from '@core/converter';

import { ITEM_TYPE_NAME } from '../../service-items.entity';

@Component({
    selector: 'service-items-tooltip',
    templateUrl: './tooltip.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ConvertDirective],
    styleUrl: '../../../items/components/item-tooltip/item-tooltip.component.scss'
})
export class ServiceItemTooltipComponent {
  public readonly ITEM_TYPE_NAME = ITEM_TYPE_NAME;
  public readonly tippy = inject(TIPPY_REF);
}
